import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import moment from 'moment';
import EmbedLiveStream from '../components/embeds/livestream';
import EmbedPlatforms from '../components/embeds/platforms';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

class PortalServiceLiveStream extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: parseInt(this.props.service),
				name: '',
			},

      embed: '',
      height: 100,
			streams: [],
			
      //PortalStage: null,
			PortalStreams: null,
		};
    
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];
		
		//value.setTheme( '/themes/default-dark.css' );
		

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${server}/v3/service/livestream`, params);
    consoleLog(x.data);
		EventEmitter.emit('/client', y);
		
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle('Live Stream', x.data.servicename);
			}
			//this.renderLiveFeed(x.data.stage);
			this.setState({streams: x.data.streams?x.data.streams:[]});
		}

		const PortalStreams = EventEmitter.addListener(`/portal/streams`, async data => {
		  //this.renderLiveFeed( data.Stage );
			console.log(data);
			if( data.service === this.state.service.id ) this.setState({streams: data.streams});
			//this.setState({next: data.Next, socials: data.Socials, meta: data.Meta, users: x.data.Users?x.data.Users:{} });
		}); this.setState({PortalStreams});
	}

	componentWillUnmount() {
		if( this.state.PortalStreams ) this.state.PortalStreams.remove();
	}

  render() {
		const user = this.context;
		
		const streams = this.state.streams.map((e,i) => {
			return (
				<tr key={i}>
					<td>
						<div className="d-flex align-items-center">
							<div className="avatar avatar-sm me-2 avatar-rounded">
								<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="img" />
							</div>
							<div>
								<div className="lh-1">
									<span>{e.title?e.title:e.username}</span>
								</div>
							</div>
						</div>
					</td>
					<td>
						{moment(e.connectCreated).format("Do MMM YYYY h:mm A")}
					</td>
					<td>
						{e.isLive===true?
							<span className="badge bg-success-transparent">LIVE</span>
						:
							<span className="badge bg-danger-transparent">DISCONNECTED</span>
						}
					</td>
						
					<td>
						<Button size="sm">Something</Button>
					</td>
				</tr>
			)
		});

		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Live Stream</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
              <Row>
                <Col lg={12}>
                  <div className="card " style={{position: 'relative'}}>
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Live Stream</span>
													<p className="fs-13 text-muted mb-0">Watch the live stream</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										<div style={{position: 'relative', display: 'inline-block'}}>
                      <EmbedLiveStream embed={this.state.service} />
                    </div>

                  </div>
                </Col>
								<Col style={{position: 'relative'}}>
									
									
										
								</Col>
							</Row>
							<EmbedPlatforms service={this.state.service} />
							
							<Row className="pt-4">
                <Col xl={12}>
                  <div className="card custom-card">
                    <div className="card-header justify-content-between">
                      <div className="card-title">
                        Admin controller
                      </div>
                    </div>
                    	<div className="card-body p-0">
												<div className="table-responsive">
													<table className="table text-nowrap table-hover">
														<thead>
															<tr>
																<th scope="col">Streamer</th>
																<th scope="col">Streaming</th>
																<th scope="col">Status</th>
																<th scope="col">Actions</th>
															</tr>
														</thead>
														<tbody>
															{streams}
														</tbody>
												</table>
											</div>
										</div>
                  </div>
                </Col>
              </Row>
            </div>
					</div>
				}
			</>
		);
	}
}

const Stream = props => {
  const { service } = useParams();
  return <PortalServiceLiveStream service={service} {...props} />
}
export default Stream;